import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
//primeflex.css
import axios from 'axios';
import VueAxios from 'vue-axios';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

//createApp(App).use(store).use(router).mount('#app')
import './assets/css/tailwind.css';
import Aura from '@primevue/themes/aura';

// import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './assets/css/primevue-custom.css'; // Ваши кастомные стили


const app = createApp(App);

// Provide apiUrl to all components
//app.provide('apiUrl', apiUrl);
///how to use it in a component
//const apiUrl = inject('apiUrl');

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{green.50}',
            100: '{green.100}',
            200: '{green.200}',
            300: '{green.300}',
            400: '{green.400}',
            500: '{green.500}',
            600: '{green.600}',
            700: '{green.700}',
            800: '{green.800}',
            900: '{green.900}',
            950: '{green.950}'
        }
    }
});
// Set Axios as a global property
//app.config.globalProperties.$http = axios;

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.dark'
        }
    }
});

app.use(store);
app.use(router);
app.use(VueAxios, axios);
//app.provide('axios', app.config.globalProperties.axios)  // provide 'axios'
app.use(ToastService);
app.use(ConfirmationService);
app.component('Toast', Toast);
app.directive('tooltip', Tooltip);

// Сначала монтируем приложение
app.mount('#app');

// Затем инициализируем авторизацию
store.dispatch('users/initializeAuth').catch(error => {
  console.error('Failed to initialize auth:', error);
});
